import {store} from "@/store/store-decorators";
import {RootStore} from "@/store/RootStore";
import {reactive} from "vue";
import CopyRule from "@/domain/maintenance/copy/CopyRule";
import WfCopyField from "@/domain/maintenance/workflow/WfCopyField";
import CopyType from "@/domain/maintenance/workflow/CopyType";
import ReasonCodeRule from "@/domain/maintenance/workflow/ReasonCodeRule";
import RevisionReason from "@/domain/maintenance/copy/RevisionReason";

type State = {
    sampleExclusiveFields: Array<WfCopyField>;
    copyRules: Array<CopyRule>;
    copyTypes: Array<CopyType>;
    reasonCodeRules: Array<ReasonCodeRule>;
    revisionReasons: Array<RevisionReason>;
}

@store
export default class ProposalCopyStore {
    private rootStore: RootStore;

    constructor(rootStore: RootStore) {
        this.rootStore = rootStore;
    }

    private state = reactive<State>({
        sampleExclusiveFields: new Array(),
        copyRules: new Array(),
        copyTypes: new Array(),
        reasonCodeRules: new Array(),
        revisionReasons: new Array(),
    })

    //contains list of fields that need values for ui to allow copy
    get copyRules(): Array<CopyRule> {
        return this.state.copyRules;
    }

    set copyRules(value: Array<CopyRule>) {
        this.state.copyRules = value;
    }

    get productEditReasonCodes(): Array<number> {
        let reasonCodes = this.state.copyRules.filter(rc => rc.hasProductNumberEdit);
        if (reasonCodes) {
            return reasonCodes.map(c => c.reasonCode);
        }
        return [];
    }

    //universal field set
    //fields for isSample option: ['sampleRequestedDate', 'sampleRequired', 'sampleRequirements',
    //             'sampleUrgencyLevel', 'sample', 'sampleCompleteDate', 'samplePromiseDate',
    //             'sampleShipDate', 'sampleStartDate', 'sampleQuantity']
    //if !isSample then return verifyFields minus sampleExclusiveFields
    get sampleExclusiveFields(): WfCopyField[] {
        return this.state.sampleExclusiveFields;
    }

    set sampleExclusiveFields(value: Array<WfCopyField>) {
        this.state.sampleExclusiveFields = value;
    }

    get copyTypes(): Array<CopyType> {
        return this.state.copyTypes;
    }

    set copyTypes(value: Array<CopyType>) {
        this.state.copyTypes = value;
    }

    get reasonCodeRules(): Array<ReasonCodeRule> {
        return this.state.reasonCodeRules;
    }

    set reasonCodeRules(value: Array<ReasonCodeRule>) {
        this.state.reasonCodeRules = value;
    }

    get revisionReasons(): Array<RevisionReason> {
        return this.state.revisionReasons;
    }

    set revisionReasons(value: Array<RevisionReason>) {
        this.state.revisionReasons = value;
    }
}